/**
 * Changes the body attribute
 */
 const changeHTMLAttribute = (attribute, value) => {
    if (document.documentElement) document.documentElement.setAttribute(attribute, value);
    return true;
}

const getHTMLAttribute = (attribute) => {
    if (document.documentElement) {
        return document.documentElement.getAttribute(attribute);
    }
    return null;
};

export { changeHTMLAttribute, getHTMLAttribute};